var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCrfIcon2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.087,
    height: 41.408,
    viewBox: "0 0 21.087 41.408",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4025",
    "data-name": "Group 4025",
    transform: "translate(-1650.244 -158.037)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4024",
    "data-name": "Group 4024",
    transform: "translate(16299.76 6708)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2696",
    "data-name": "Path 2696",
    d: "M49.329,77.1a.631.631,0,0,0-.631.631V84.18a.631.631,0,1,0,1.262,0V77.728A.631.631,0,0,0,49.329,77.1Z",
    transform: "translate(-14689.022 -6593.616)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2697",
    "data-name": "Path 2697",
    d: "M56.635,77.1a.631.631,0,0,0-.631.631v2.365a.631.631,0,1,0,1.262,0V77.728A.631.631,0,0,0,56.635,77.1Z",
    transform: "translate(-14692.893 -6593.616)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2698",
    "data-name": "Path 2698",
    d: "M42.024,77.1a.631.631,0,0,0-.631.631v3a.631.631,0,1,0,1.262,0v-3A.631.631,0,0,0,42.024,77.1Z",
    transform: "translate(-14685.152 -6593.616)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2699",
    "data-name": "Path 2699",
    d: "M45.782,24.228a3.745,3.745,0,1,0,3.745,3.745A3.749,3.749,0,0,0,45.782,24.228Zm0,6.228a2.483,2.483,0,1,1,2.483-2.483A2.486,2.486,0,0,1,45.782,30.456Z",
    transform: "translate(-14684.494 -6565.61)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_19631",
    "data-name": "Path 19631",
    d: "M48.549,27.8l-1.6-1.878c.2-1.368.86-7.056-1.12-11.572a16.14,16.14,0,0,0-2.595-4.06A19.109,19.109,0,0,0,40.519,7.72q-.38-.3-.775-.572c-.1-.071-.2-.141-.309-.21-.037-.024-.074-.05-.111-.077a1.376,1.376,0,0,0-1.283-.3,2.619,2.619,0,0,0-.778.452c-.059.045-.117.089-.175.13-.361.251-.726.526-1.084.816a18.909,18.909,0,0,0-2.732,2.712A15.985,15.985,0,0,0,31,14.353c-1.981,4.516-1.32,10.2-1.12,11.572l-1.6,1.878a.631.631,0,0,0-.123.594l2.982,9.737a.631.631,0,0,0,1.112.189,7.332,7.332,0,0,1,2.425-2.065v.185a.631.631,0,0,0,.631.631h6.221a.631.631,0,0,0,.631-.631v-.185a7.33,7.33,0,0,1,2.425,2.065.632.632,0,0,0,.508.257.67.67,0,0,0,.106-.009.63.63,0,0,0,.5-.437L48.672,28.4A.629.629,0,0,0,48.549,27.8Zm-3.733,8.875A6.078,6.078,0,0,0,41.61,34.8a.614.614,0,0,0-.088-.006.631.631,0,0,0-.631.631v.391H35.932v-.391a.631.631,0,0,0-.719-.625,6.073,6.073,0,0,0-3.206,1.882l-2.547-8.32,1.565-1.835a.63.63,0,0,0,.142-.517c-.011-.063-1.083-6.431.986-11.146a14.725,14.725,0,0,1,2.1-3.391,17.654,17.654,0,0,1,2.55-2.53c.333-.27.673-.526,1.009-.759.073-.051.146-.106.22-.163a3.513,3.513,0,0,1,.359-.255,1.257,1.257,0,0,1,.206.13c.048.034.1.069.146.1.1.063.19.127.283.192q.368.256.72.531a17.876,17.876,0,0,1,2.534,2.4,14.894,14.894,0,0,1,2.394,3.742c2.065,4.707,1,11.082.986,11.146a.63.63,0,0,0,.142.517l1.565,1.835Z",
    transform: "translate(1622.375 151.781)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrfIcon2);
export default __webpack_public_path__ + "static/media/CRFIcon2.1901d876.svg";
export { ForwardRef as ReactComponent };